import React from "react";
import AutomationLayout from "app/components/Layouts/AutomationLayout";
import WorkflowsList from "./_components/WorkflowsList";
import styles from "./styles.module.scss";

const AutomationPage = () => {
  return (
    <div className={styles.container}>
      <AutomationLayout>
        <div className={styles.wrapper}>
          <WorkflowsList />
        </div>
      </AutomationLayout>
    </div>
  );
};

export default AutomationPage;
